module.exports = __webpack_public_path__ + "img/slide03.d7779ddc.jpg";